import React, { useState, useEffect } from 'react'
import MeasurementTypeDoubleBox from '../Shared/MeasurementTypeDoubleBox'
import moment from 'moment-jalaali'
import TaskCode from '../Shared/TaskCode'

const ProductOperationDetails = props => {

  const [data, setData] = useState(props.data)

  useEffect(() => {



  }, [])


  return (
    <React.Fragment>
      <fieldset className="fieldset">
        <legend>اطلاعات محصول</legend>
        <table className="table validator-table" style={{ marginBottom: 5 }}>
          <thead>
            <tr>
              <th className="text-center">دسته بندی</th>
              <th className="text-center">برند</th>
              <th className="text-center">نام کالا</th>
              <th className="text-center">کد کالا</th>
              <th className="text-center">کد کوتاه</th>
            </tr>
          </thead>
          <tbody>

            <tr>
              <td>
                {data.unitProduct.product && data.unitProduct.product.category.name}
              </td>
              <td>
                {data.unitProduct.product && data.unitProduct.product.brand.name}
              </td>
              <td>
                {data.unitProduct.product && data.unitProduct.product.name}
              </td>
              <td>
                {data.unitProduct.product && data.unitProduct.product.extraCode}
              </td>
              <td>
                {data.unitProduct.product && data.unitProduct.product.shortExtraCode}
              </td>

            </tr>

          </tbody>
        </table>
      </fieldset>

      <fieldset className="fieldset">
        <legend>اطلاعات ورود و خروج کالا</legend>
        <table className="table validator-table" style={{ marginBottom: 5 }}>
          <thead>
            <tr>
              <th className="text-center">موجودی قبلی</th>
              <th className="text-center">مقدار ورود / خروج</th>
              <th className="text-center">موجودی اصلی</th>
              <th className="text-center">کاربر ثبت کننده</th>
              <th className="text-center">تاریخ ثبت</th>
              <th className="text-center">کد سفارش</th>
            </tr>
          </thead>
          <tbody>

            <tr>
              <td>
                {data.previousQuantity !== undefined
                  ? <MeasurementTypeDoubleBox
                    product={data.unitProduct.product}
                    value={data.previousQuantity}
                  />
                  : ''}
              </td>
              <td>
                {data.quantity !== undefined
                  ? <MeasurementTypeDoubleBox
                    product={data.unitProduct.product}
                    value={data.quantity}
                    sign={data.unitProductOperationType == 0 ? '+' : '-'}
                  />
                  : ''}
              </td>
              <td>
                {data.nextQuantity !== undefined
                  ? <MeasurementTypeDoubleBox
                    product={data.unitProduct.product}
                    value={data.nextQuantity}
                  />
                  : 0}
              </td>
              <td>
                {data.user.fullName}
              </td>
              <td>
                {moment(data.createdAt, "YYYY/M/D H:m").format("jYYYY/jM/jD ساعت H:mm")}
              </td>
              <td>
                <TaskCode code={data.taskCode} />
              </td>

            </tr>

          </tbody>
        </table>
      </fieldset>
    </React.Fragment>
  )
}

export default ProductOperationDetails;